import { createApp } from 'vue'
import App from './App.vue'
import 'materialize-css/dist/js/materialize.min'




const app = createApp(App)

app
.mount('#app')



